export default __webpack_public_path__ + "static/media/gw8.49ebfc03.webp";